import { createAction } from 'redux-actions';


export const NAMES = {
  SHOW: 'CLIENT.VIDEO.PLAYER_UI.SHOW',
  HIDE: 'CLIENT.VIDEO.PLAYER_UI.HIDE',
};

export const showPlayerUI = createAction(NAMES.SHOW);
export const hidePlayerUI = createAction(NAMES.HIDE);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/player/ui.js